import { z } from 'zod';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export { UserRole } from '../__generated__/graphql/api';

import { UserRole } from '../__generated__/graphql/api';

interface RoleMimickingStore {
  currentRole: UserRole;
  isMimicking: boolean;
  setRole: (role: UserRole) => void;
  reset: () => void;
}

const LOCAL_STORAGE_KEY = 'role-mimicking';

const persistedRoleSchema = z.object({ currentRole: z.nativeEnum(UserRole), isMimicking: z.boolean() });

export const useRoleMimickingStore = create<RoleMimickingStore>()(
  devtools(
    persist(
      (set) => ({
        currentRole: UserRole.SuperAdmin,
        isMimicking: false,

        setRole: (role: UserRole) => {
          set({ currentRole: role, isMimicking: true });
        },

        reset: () => {
          set({ currentRole: UserRole.SuperAdmin, isMimicking: false });
        },
      }),
      {
        name: LOCAL_STORAGE_KEY,
        version: 1,
        migrate: (persistedState) => {
          const persisted = persistedRoleSchema.safeParse(persistedState);

          return persisted.success ? persisted.data : { currentRole: UserRole.SuperAdmin, isMimicking: false };
        },
      },
    ),
    { name: 'role-mimicking' },
  ),
);
